import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertMessageComponent } from './alert-message/alert-message.component';
import { AlertMessagesComponent } from './alert-messages.component';
import { PostsStoreModule } from '@stop-counter/stores';
import { ButtonModule, ScrollService } from '@apps/ui';
import { RouterModule } from '@angular/router';
import { CounterDownModule } from '../counter-down/counter-down.module';
import { AlertPerProductPipe } from './alert-per-product.pipe';
import { AlertPerTypePipe } from './alert-per-type.pipe';
import { AnimateArrowsComponent } from './animate-arrows/animate-arrows.component';
import { ChristmasLightsComponent } from './christmas-lights/christmas-lights.component';

@NgModule({
  declarations: [AlertMessageComponent, AlertMessagesComponent, AlertPerProductPipe, AlertPerTypePipe, AnimateArrowsComponent, ChristmasLightsComponent],
  exports: [AlertMessagesComponent],
  imports: [CommonModule, RouterModule, PostsStoreModule, ButtonModule, CounterDownModule],
  providers: [ScrollService]
})
export class AlertMessagesModule {}
